export default __webpack_public_path__ + "static/media/logo-muffin.eeec5ce6.svg";